// extracted by mini-css-extract-plugin
export default {"root":"ways-to-help-message_root__DcJch"};